import { hardenWindowOpen } from '@wix/client-security'

export const hardenOpenWindow = hardenWindowOpen
